import React, { Component } from "react";
import PropTypes from "prop-types";
import IconWithBackground from "containers/chat/IconWithBackground/IconWithBackground";
import { ReactComponent as CommentDotsIcon } from "images/chat/comment-dots.svg";
import "./DisposeForm.scss";
import Input from "components/Input/Input";
import RadioGroup from "components/RadioGroup/RadioGroup";
import { Col, Row } from "react-bootstrap";
import Select from "react-select";
import { uepClient } from "uepClient";
import Button from "Button/Button";
import { connect } from "react-redux";
import { MdEdit } from "react-icons/md";
import { disposeCurrentConversation } from "actions/conversationActions";
import { ConversationStatus } from "constants/ChatListingConstants";
import MessageSuggestionService from "services/MessageSuggestionService";
import WithAlert from "hoc/WithAlert";
import { getBusinessUnit, getGroup } from "utils/Common";
import { UserBU, UserChannel, UserGroup } from "constants/UserConstants";
import moment from "moment";

class DisposeForm extends Component {
  static propTypes = {
    className: PropTypes.string,
    activeConversationId: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    conversations: PropTypes.array,
  };

  static defaultProps = {
    className: "",
  };

  constructor() {
    super();
    this.state = {
      title: null,
      name: "",
      email: "",
      contact: "",
      city: "",
      state: "",
      pinCode: "",
      campaignId: "",
      model: null,
      dispositionQuery: null,
      subDispositionQuery: null,
      notes: "",
      isLoading: true,
      isFormSubmissionInProgress: false,
      isEditMode: false,
      isFieldEditable: {
        title: false,
        contact: false,
        name: false,
        email: false,
        city: false,
        pinCode: false,
        campaignId: false,
      },
    };
    this.customerId = "";
    this.dispositionData = [];
    this.dispositionOptions = [];
    this.modelOptions = [];
    this.subDispositionOptions = new Map();
    this.group = getGroup();
    this.businessUnit = getBusinessUnit();
    this.channel = null;
  }

  isCVSales = () => {
    return this.businessUnit === UserBU.CV && this.group === UserGroup.SALES;
  };

  componentDidMount() {
    this.getDispositionData();
    this.populateFormWithConversationMeta();
    if (this.isCVSales()) {
      this.getCampaignId();
      this.fetchAndSetModelOptions();
    }
  }

  getCampaignId = () => {
    const { activeConversationId } = this.props;
    uepClient()
      .get(`/conversation-metadata/${activeConversationId}`)
      .then((res) => {
        if (res.data) {
          const metaData = res.data;
          this.setState({
            campaignId: metaData.campaignId,
            isFieldEditable: {
              ...this.state.isFieldEditable,
              campaignId: !Boolean(res.data),
            },
          });
        }
      });
  };

  getDispositionData = () => {
    uepClient()
      .get(`/disposition-query/${this.group}`)
      .then((res) => {
        this.dispositionData = res.data;
        this.dispositionOptions = this.dispositionData.map((d) => {
          const subDispositionOptions = d.subDispositions.map((sd) => ({
            value: sd.id,
            label: sd.subDisposition,
          }));
          this.subDispositionOptions.set(d.id, subDispositionOptions);
          return {
            value: d.id,
            label: d.disposition,
          };
        });
        this.setState({
          isLoading: false,
        });
      });
  };

  fetchAndSetModelOptions = () => {
    uepClient()
      .get(`/product-lines`)
      .then((res) => {
        const modelOptions = res.data;
        modelOptions.forEach((option) => {
          this.modelOptions.push({
            value: option.id,
            label: option.parentProductLine,
          });
          option.productLines.forEach((productLine) => {
            this.modelOptions.push({
              value: productLine.id,
              label: productLine.productLine,
            });
          });
        });
      })
      .catch((err) => {
        console.error(`Failed  to fetch product lines - ${err}`);
      });
  };

  getCurrentConversation = () => {
    const { conversations, activeConversationId } = this.props;
    const currentConversation = conversations.find(
      (c) => c.conversationId === activeConversationId
    );
    return currentConversation;
  };

  populateFormWithConversationMeta = () => {
    const currentConversation = this.getCurrentConversation();
    if (currentConversation && currentConversation.conversationMeta) {
      const { conversationMeta } = currentConversation;
      const {
        title,
        name,
        email,
        city,
        state,
        pinCode,
        phoneNumber,
        customerId,
        channel,
      } = conversationMeta;
      this.customerId = customerId;
      this.channel = channel;
      this.setState({
        contact: phoneNumber,
        title: title,
        name: name,
        email: email,
        city: city,
        state: state,
        pinCode: pinCode,
        isFieldEditable: {
          ...this.state.isFieldEditable,
          title: !Boolean(title && title.trim()),
          name: !Boolean(name && name.trim()),
          contact: !Boolean(phoneNumber && phoneNumber.trim()),
          email: !Boolean(email && email.trim()),
          city: !Boolean(city && city.trim()),
          state: !Boolean(state && state.trim()),
          pinCode: !Boolean(pinCode && pinCode.toString().trim()),
        },
      });
    }
  };

  onFormSubmit = (e) => {
    e.preventDefault();
    this.submitDisposition();
  };

  submitDisposition = () => {
    const {
      title,
      name,
      email,
      contact,
      city,
      state,
      pinCode,
      dispositionQuery,
      subDispositionQuery,
      notes,
      campaignId,
      model,
    } = this.state;
    const {
      activeConversationId,
      onFormClose,
      disposeCurrentConversation,
    } = this.props;
    const dispositionData = {
      client: {
        title,
        name,
        email,
        phone: contact,
        customerId: this.customerId,
        city,
        state,
        pincode: pinCode,
        channel: this.channel,
      },
      dispositionQueryId: dispositionQuery.value,
      subDispositionQueryId: subDispositionQuery.value,
      conversationId: activeConversationId,
      notes,
      metaData: {
        campaignId,
        model: model ? model.label : null,
      },
    };
    this.setState({ isFormSubmissionInProgress: true });
    const lastMessageTime = moment();
    uepClient()
      .post("/disposition", JSON.stringify(dispositionData))
      .then(() => {
        this.setState({ isFormSubmissionInProgress: false });
        onFormClose();
        const conversation = this.props.conversations.find(
          (c) => c.conversationId === activeConversationId
        );
        const conversationMessages = conversation.messages;
        const firstMessage = conversationMessages[0];

        const disposedConversation = {
          conversationId: activeConversationId,
          messages: conversationMessages,
          status: ConversationStatus.CLOSED,
          conversationMeta: {
            customerId: this.customerId,
            phoneNumber: contact,
            name: name,
            email: email,
            city: city,
            state: state,
            pinCode: pinCode,
            title: title,
            disposition: dispositionQuery.label,
            subDisposition: subDispositionQuery.label,
            startTime: firstMessage.messageTime,
            endTime: lastMessageTime,
            channel: firstMessage.channel,
          },
          chatTransferDetails: [],
        };
        MessageSuggestionService.resetSuggestion(); //CLose suggestion tab and show canned messages
        disposeCurrentConversation(disposedConversation);
      })
      .catch((err) => {
        this.props.showAlert({
          variant: "danger",
          content: (
            <span>
              <b>Error!</b> Failed to dispose the conversation, Please try
              again.
            </span>
          ),
        });
        console.error(err.message);
        this.setState({ isFormSubmissionInProgress: false });
      });
  };

  getSalutationOptions = () => {
    return [
      {
        value: "MR",
        label: "Mr.",
      },
      {
        value: "MS",
        label: "Ms.",
      },
      {
        value: "MRS",
        label: "Mrs.",
      },
    ];
  };

  handleFormInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  renderFormInputWithHeader = (header, content, isBoldHeader = false) => {
    const boldHeaderCls = isBoldHeader ? "bold" : "";
    return (
      <div className="form-input-with-header">
        {header === "Notes" ? (
          <div className="notes-header">
            <div className={`form-section-header ${boldHeaderCls}`}>
              {header}
            </div>
            <div className="notes-char-limit"> (max 1000 characters) </div>
          </div>
        ) : (
          <div className={`form-section-header ${boldHeaderCls}`}>{header}</div>
        )}

        <div className="form-section-content">{content}</div>
      </div>
    );
  };

  onTitleChange = (title) => {
    this.setState({
      title,
    });
  };

  getDispositionOptions = () => {
    return this.dispositionOptions;
  };

  getSubDispositionOptions = () => {
    const { dispositionQuery } = this.state;
    if (dispositionQuery) {
      return this.subDispositionOptions.get(dispositionQuery.value);
    } else return [];
  };

  onDispositionQueryChange = (selectedDisposition) => {
    this.setState({
      dispositionQuery: selectedDisposition,
      subDispositionQuery: null,
    });
  };

  onSubDispositionChange = (selectionSubDis) => {
    this.setState({
      subDispositionQuery: selectionSubDis,
    });
  };

  getDropdownStyles = () => {
    const customStyles = {
      container: (provided) => ({
        ...provided,
        width: "100%",
      }),
      control: (provided, { isDisabled }) => ({
        ...provided,
        width: "100%",
        minWidth: 120,
        height: 34,
        minHeight: 34,
        font: "normal normal bold 14px/19px Roboto",
        background: "white",
        paddingLeft: "0px",
        opacity: isDisabled ? 0.5 : 1,
        boxShadow: "0px 3px 6px #00000029",
        border: 0,
      }),
      option: (provided) => ({
        ...provided,
        width: "100%",
        minWidth: 120,
        font: "Roboto",
        border: "none",
      }),
      dropdownIndicator: (provided, state) => ({
        ...provided,
        width: 28,
        paddingTop: 0,
        paddingBottom: 0,
        color: "#3c3c3f",
        transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : null,
      }),
      singleValue: (provided) => ({
        ...provided,
      }),
      menu: (provided) => ({
        ...provided,
      }),
      placeholder: (provided) => ({
        ...provided,
        fontWeight: "normal",
      }),
    };
    return customStyles;
  };

  canSubmit = () => {
    const {
      contact,
      pinCode,
      dispositionQuery,
      subDispositionQuery,
      model,
    } = this.state;

    const isModelValid = !this.isCVSales() || Boolean(model);
    const isPincodePresent = !this.isCVSales() || (this.isCVSales() && pinCode);
    const isContactValid = contact ? contact.toString().trim() : true;

    return (
      (isContactValid || this.channel === UserChannel.TELEGRAM) &&
      dispositionQuery &&
      subDispositionQuery &&
      isModelValid &&
      isPincodePresent
    );
  };

  onFormClose = () => {
    const { onFormClose } = this.props;
    onFormClose();
  };

  onFormCancel = (e) => {
    e.preventDefault();
    this.onFormClose();
  };

  onFormEdit = () => {
    this.setState({
      isEditMode: true,
    });
  };

  onModelChange = (model) => {
    this.setState({
      model,
    });
  };

  render() {
    const {
      title,
      name,
      email,
      state,
      city,
      contact,
      pinCode,
      campaignId,
      model,
      dispositionQuery,
      subDispositionQuery,
      isLoading,
      isFormSubmissionInProgress,
      isEditMode,
      isFieldEditable,
    } = this.state;
    return (
      <div className="disposition-form">
        <div className="disposition-form-header">
          <div className="comment-icon">
            <IconWithBackground icon={<CommentDotsIcon />} />
          </div>
          <div className="header-label">Disposition</div>
          <MdEdit className="edit-icon" onClick={this.onFormEdit} />
        </div>
        <div className="form-content">
          <form className="dispose-form" onSubmit={this.onFormSubmit}>
            <div className="form-section salutation">
              {this.renderFormInputWithHeader(
                "Title",
                <RadioGroup
                  options={this.getSalutationOptions()}
                  onChange={this.onTitleChange}
                  value={title}
                  readOnly={
                    Boolean(title) && !isEditMode && !isFieldEditable.title
                  }
                />
              )}
            </div>
            <div className="form-section name-and-email">
              <Row noGutters>
                <Col xs="6">
                  {this.renderFormInputWithHeader(
                    "Name",
                    <Input
                      name="name"
                      onChange={this.handleFormInputChange}
                      type="text"
                      pattern="^[a-zA-Z ]*$"
                      title="Characters only"
                      value={name}
                      readOnly={
                        Boolean(name) && !isEditMode && !isFieldEditable.name
                      }
                    />
                  )}
                </Col>
                <Col xs="6">
                  {this.renderFormInputWithHeader(
                    "Email",
                    <Input
                      name="email"
                      onChange={this.handleFormInputChange}
                      type="email"
                      value={email}
                      readOnly={
                        Boolean(email) && !isEditMode && !isFieldEditable.email
                      }
                    />
                  )}
                </Col>
              </Row>
            </div>
            <div className="form-section contact-and-city">
              <Row noGutters>
                <Col xs="6">
                  {this.renderFormInputWithHeader(
                    "Contact",
                    <Input
                      name="contact"
                      onChange={this.handleFormInputChange}
                      type="tel"
                      pattern="^[0-9]*$"
                      title="Digits only"
                      value={contact}
                      readOnly={
                        Boolean(contact) &&
                        !isEditMode &&
                        !isFieldEditable.contact
                      }
                    />
                  )}
                </Col>
                <Col xs="6">
                  {this.renderFormInputWithHeader(
                    "City",
                    <Input
                      name="city"
                      onChange={this.handleFormInputChange}
                      type="text"
                      pattern="^[a-zA-Z ]*$"
                      title="Characters only"
                      value={city}
                      readOnly={
                        Boolean(city) && !isEditMode && !isFieldEditable.city
                      }
                    />
                  )}
                </Col>
              </Row>
            </div>
            <div className="form-section state-and-pin">
              <Row noGutters>
                <Col xs="6">
                  {this.renderFormInputWithHeader(
                    "State",
                    <Input
                      name="state"
                      onChange={this.handleFormInputChange}
                      type="text"
                      pattern="^[a-zA-Z ]*$"
                      title="Characters only"
                      value={state}
                      readOnly={
                        Boolean(state) && !isEditMode && !isFieldEditable.state
                      }
                    />
                  )}
                </Col>
                <Col xs="6">
                  {this.renderFormInputWithHeader(
                    <span className={this.isCVSales() ? "required" : ""}>
                      Pin Code
                    </span>,
                    <Input
                      name="pinCode"
                      onChange={this.handleFormInputChange}
                      type="number"
                      value={pinCode}
                      readOnly={
                        Boolean(pinCode) &&
                        !isEditMode &&
                        !isFieldEditable.pinCode
                      }
                    />
                  )}
                </Col>
              </Row>
            </div>
            {this.isCVSales() && (
              <>
                <div className="form-section meta-info">
                  <Row noGutters>
                    <Col xs="6">
                      {this.renderFormInputWithHeader(
                        "Campaign Id",
                        <Input
                          name="campaignId"
                          onChange={this.handleFormInputChange}
                          type="text"
                          value={campaignId}
                          readOnly={
                            Boolean(campaignId) &&
                            !isEditMode &&
                            !isFieldEditable.campaignId
                          }
                        />
                      )}
                    </Col>
                  </Row>
                </div>
                <div className="form-section model">
                  {this.renderFormInputWithHeader(
                    <span className="required">Model</span>,
                    <Select
                      onChange={this.onModelChange}
                      value={model}
                      options={this.modelOptions}
                      placeholder="Search Model"
                      styles={this.getDropdownStyles()}
                      isLoading={isLoading}
                    />,
                    true
                  )}
                </div>
              </>
            )}
            <div className="form-section query">
              {this.renderFormInputWithHeader(
                <span className="required">Query</span>,
                <Select
                  onChange={this.onDispositionQueryChange}
                  value={dispositionQuery}
                  options={this.getDispositionOptions()}
                  placeholder="Search Disposition"
                  styles={this.getDropdownStyles()}
                  isLoading={isLoading}
                />,
                true
              )}
            </div>
            <div className="form-section query">
              {this.renderFormInputWithHeader(
                <span className="required">Sub-Disposition </span>,
                <Select
                  onChange={this.onSubDispositionChange}
                  value={subDispositionQuery}
                  options={this.getSubDispositionOptions()}
                  placeholder="Search Sub-Disposition"
                  styles={this.getDropdownStyles()}
                  isLoading={isLoading}
                  isDisabled={!dispositionQuery}
                />,
                true
              )}
            </div>
            <div className="form-section notes">
              {this.renderFormInputWithHeader(
                "Notes",
                <textarea
                  className="notes-textbox"
                  onChange={this.handleFormInputChange}
                  name="notes"
                  maxLength={1000}
                />,
                true
              )}
            </div>
            <div className="buttons-container">
              <Button
                className="form-cancel-btn"
                label="Cancel"
                disabled={isFormSubmissionInProgress}
                onClick={this.onFormCancel}
                isTransparent
              />
              <Button
                className="form-submit-btn"
                type="submit"
                label="Confirm"
                disabled={!this.canSubmit()}
                isLoading={isFormSubmissionInProgress}
              />
            </div>
          </form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  activeConversationId: state.conversation.activeConversationId,
  conversations: state.conversation.conversations,
});

const mapDispatchToProps = {
  disposeCurrentConversation,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WithAlert(DisposeForm));
